import React from "react";
import GameObjects from "../../../Question/View/GameObjects";

class HorizontalMove extends React.Component {

    constructor(props) {
        super(props);
        this.timer = "";
        this.designerContainer = React.createRef();
        this.state = {
            top: this.props.top ? this.props.top : Math.floor(Math.random() * 100),
            isShow: false,
            updatePosition: this.updatePosition,
            left: 0,
            delay: this.props.delay ? (this.props.delay * 1000) : (Math.floor(Math.random() * 10) * 300),
            timerSound: "",
            zIndex: 19,
            speed: this.props.designerContainer.current.clientHeight / this.props.Time,
            isHide: false,
            isHover: false,
            objectMovmentId: Math.floor(Math.random() * 100000),
            isTop: true
        };
    }

    componentDidMount() {
        let timeout = this.state.delay;
        setTimeout(() => {
            this.setState({
                isShow: true
            });
            if (this.state.top > 80) {
                this.setState({
                    isTop: false,
                    top: 100 - this.state.top
                });
            }
            this.timer = setInterval(() => {
                if (this.designerContainer && this.designerContainer.current && this.props.designerContainer && this.props.designerContainer.current && !this.state.isHide) {
                    this.fall();
                }
            }, 30);
        }, timeout);
    }

    fall = () => {
        if (this.state.left < this.props.designerContainer.current.clientWidth - this.designerContainer.current.clientWidth) {
            this.setState({
                left: this.state.left + this.state.speed / 30
            });
        } else {
            this.props.handelDropObject(this.props.param, false);
            this.setState({
                isHide: true
            });
        }
        this.checkIfCaught();
    }

    checkIfCaught = () => {
        if (this.props.basket && this.props.basket.current) {
            const box = this.props.basket.current.getBoundingClientRect();
            if (this.designerContainer && this.designerContainer.current) {
                const object = this.designerContainer.current.getBoundingClientRect();
                if (object.x >= box.x &&
                    object.x <= (box.x + box.width) &&
                    (object.y + object.height) >= box.y &&
                    object.y <= (box.y + box.height)) {
                    this.props.handelDropObject(this.props.param, true);
                    this.setState({
                        isHide: true
                    });
                }
            }
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        if (this.props.designerContainer && this.props.designerContainer.current && !this.state.isHide && this.state.isShow) {
            let style = {
                left: `${this.state.left}px`,
                zIndex: this.state.zIndex ? this.state.zIndex : 19
            };
            if (this.state.isTop) {
                style = {
                    top: `${this.state.top}%`,
                    ...style
                }

            } else {
                style = {
                    bottom: `${this.state.top}%`,
                    ...style
                }
            }
            return <div ref={this.designerContainer}
                className={`position-absolute objectMovment `}
                id={`objectMovment${this.state.objectMovmentId}`}
                style={style}>
                <GameObjects   {...this.props} type="dragdrop-move" />
            </div>;
        }
        return "";
    }
}

export default HorizontalMove;